import * as React from "react";
import { Box } from "@mui/material";
import Grid2 from '@mui/material/Grid2';
import MoveButton from "components/Flow/Tabs/ItemMovementTabs/MoveButton";
import { useTheme } from "@mui/material/styles";
import AddItemButton from "components/Flow/Tabs/ItemMovementTabs/AddItemButton";
import RemoveItemButton from "components/Flow/Tabs/ItemMovementTabs/RemoveItemButton";

interface ControlPanelProps {
  inputFunctionalities: any[];
  outputFunctionalities: any[];

  selectedInputID: string;
  selectedOutputID: string;

  setSelectedInput: (id: string) => void;
  setSelectedOutput: (id: string) => void;

  handleMove: (direction: "forward" | "backward") => void;

  // 🔥 NEW REQUIRED props needed for Add/Remove item
  nodeData: any;
  items: any[];
  itemType: "People" | "Addresses";
  selectedItems: any[];
  refreshItems: () => void;

  nodeAPI: {
    updateField: (id: number, field: string, value: any) => Promise<any>;
  };

  itemAPI: {
    getAll: () => Promise<any[]>;
  };

  // 🔥 Dynamic selectors (optional)
  inputTypeField?: string;
  outputTypeField?: string;
  inputLabelField?: string;
  outputLabelField?: string;
  disabled?: boolean;
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  inputFunctionalities,
  outputFunctionalities,
  selectedInputID,
  selectedOutputID,
  setSelectedInput,
  setSelectedOutput,
  handleMove,

  // NEW props
  nodeData,
  items,
  itemType,
  selectedItems,
  refreshItems,
  nodeAPI,
  itemAPI,

  inputTypeField,
  outputTypeField,
  inputLabelField,
  outputLabelField,
  disabled = false,
}) => {
  const theme = useTheme();
  
  const buttonColor =
    theme.custom.modules.campaigns.primary ?? theme.custom.base.primary.dark;

  return (
    <Box>
      <Grid2 container>
        {/* ================= BACKWARD ================= */}
        <Grid2 size={4} alignItems="left">
          <MoveButton
            direction="backward"
            label="Input Source"
            functionalities={inputFunctionalities}
            selectedID={selectedInputID}
            onSelectChange={setSelectedInput}
            onMoveClick={() => handleMove("backward")}
            inputTypeField={inputTypeField}
            inputLabelField={inputLabelField}
            disabled={disabled}
          />
        </Grid2>

        {/* ================= ADD ITEMS ================= */}
        <Grid2 size={2} alignItems="center">
          <AddItemButton
            nodeId={nodeData.id}
            fieldName={itemType.toLowerCase()}
            itemType={itemType}
            itemAPI={itemAPI}
            nodeAPI={nodeAPI}
            currentItems={items}
            onAdded={refreshItems}
          />
        </Grid2>

        {/* ================= REMOVE ITEMS ================= */}
        <Grid2 size={2} alignItems="center">
          <RemoveItemButton
            nodeId={nodeData.id}
            fieldName={itemType.toLowerCase()}
            nodeAPI={nodeAPI}
            itemType={itemType}
            currentItems={items}
            selectedItems={selectedItems}
            onRemoved={refreshItems}
          />
        </Grid2>
        
        {/* ================= FORWARD ================= */}
        <Grid2 size={4} alignItems="right">
          <MoveButton
            direction="forward"
            label="Output Target"
            functionalities={outputFunctionalities}
            selectedID={selectedOutputID}
            onSelectChange={setSelectedOutput}
            onMoveClick={() => handleMove("forward")}
            outputTypeField={outputTypeField}
            outputLabelField={outputLabelField}
            disabled={disabled}
          />
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default ControlPanel;
